var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8986 17.9982C31.8986 15.1127 29.5594 12.7734 26.6738 12.7734C23.7882 12.7734 21.449 15.1127 21.449 17.9982V23.3997C21.449 26.2852 23.7882 28.6244 26.6738 28.6244C29.5594 28.6244 31.8986 26.2852 31.8986 23.3997V17.9982Z",
    stroke: "#52606E",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.076 28.7324L21.8828 31.9478H17.0938C14.7004 31.9478 12.7737 34.049 12.7737 36.6587V38.3495C12.7737 39.5811 13.7768 40.5736 15.0216 40.5736H38.3256C39.5705 40.5736 40.5736 39.5811 40.5736 38.3495V36.6587C40.5736 34.049 38.647 31.9478 36.2535 31.9478H31.4645L28.2713 28.7324H25.076Z",
    stroke: "#52606E",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon_profile.4be0f2fb1320811a13e69ae8eb39cb86.svg";
export { ForwardRef as ReactComponent };